import { Ban, Images, Tags, X } from 'lucide-react'

interface NoImageOptionsProps {
  onGoToBrands: () => void
  onGoToGallery: () => void
  onDeactivate: () => void
  onMarkNoImage: () => void
  isLoading: boolean
}

export function NoImageOptions({
  onGoToBrands,
  onGoToGallery,
  onDeactivate,
  onMarkNoImage,
  isLoading
}: NoImageOptionsProps) {
  return (
    <div className="bg-[#FCD016]/10 dark:bg-[#FCD016]/10 border border-[#FCD016] dark:border-[#FCD016] rounded-lg p-3 sm:p-4">
      <p className="text-xs sm:text-sm font-semibold text-[#D9B20F] dark:text-[#FCD016] mb-2 sm:mb-3">Ações rápidas</p>

      <div className="grid grid-cols-2 gap-1 sm:gap-2">
        <button
          onClick={onGoToBrands}
          disabled={isLoading}
          className="h-14 sm:h-16 w-full px-2 bg-[#414142] hover:bg-[#2D2D2E] text-white font-semibold rounded transition disabled:opacity-50 text-xs sm:text-sm hover:shadow-md flex items-center justify-center gap-1 text-center leading-tight"
        >
          <Tags size={12} className="sm:block hidden" />
          <Tags size={10} className="sm:hidden" />
          <span className="hidden sm:inline">Painel de Marcas</span>
          <span className="sm:hidden">Marcas</span>
        </button>

        <button
          onClick={onDeactivate}
          disabled={isLoading}
          className="h-14 sm:h-16 w-full px-2 bg-[#D9B20F] hover:bg-[#C9A20D] dark:bg-[#FCD016] dark:hover:bg-[#E5C700] text-[#18181A] font-semibold rounded transition disabled:opacity-50 text-xs sm:text-sm hover:shadow-md flex items-center justify-center gap-1 text-center leading-tight"
        >
          <Ban size={12} className="sm:block hidden" />
          <Ban size={10} className="sm:hidden" />
          <span className="hidden sm:inline">Desativado</span>
          <span className="sm:hidden">Desativ.</span>
        </button>

        <button
          onClick={onGoToGallery}
          disabled={isLoading}
          className="h-14 sm:h-16 w-full px-2 bg-slate-700 hover:bg-slate-800 text-white font-semibold rounded transition disabled:opacity-50 text-xs sm:text-sm hover:shadow-md flex items-center justify-center gap-1 text-center leading-tight"
        >
          <Images size={12} className="sm:block hidden" />
          <Images size={10} className="sm:hidden" />
          <span className="hidden sm:inline">Galeria</span>
          <span className="sm:hidden">Galeria</span>
        </button>

        <button
          onClick={onMarkNoImage}
          disabled={isLoading}
          className="h-14 sm:h-16 w-full px-2 bg-[#5A5A5E] hover:bg-[#414142] text-white font-semibold rounded transition disabled:opacity-50 text-xs sm:text-sm hover:shadow-md flex items-center justify-center gap-1 text-center leading-tight"
        >
          <X size={12} className="sm:block hidden" />
          <X size={10} className="sm:hidden" />
          <span className="hidden sm:inline">Sem Imagem</span>
          <span className="sm:hidden">Sem</span>
        </button>
      </div>
    </div>
  )
}
